import {
  Document,
  Font,
  G,
  Page,
  Path,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";

import { CartDetails } from "../lib/cart/CartDetails";
import React from "react";
import dayjs from "dayjs";

Font.register({
  family: "ST Monochromic Regular",
  src: "https://fonts-priv.vercel.app/iaohe8rq2rh2981rt901thf8g032038gh/STMonochromicv.01-Regular.otf",
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "ST Monochromic Regular",
    fontSize: "12px",
    padding: 20,
  },
  licenseDetails: {
    flexGrow: 1,
  },
  items: {},
  spacedRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  discounts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#1c8249",
  },
});

interface Props {
  cartDetails: CartDetails;
}

function Logo() {
  return (
    <Svg
      id="Layer_2_00000066497432824446310070000006144457392408803518_"
      viewBox="0 0 296 296"
      style={{ width: 40, height: 40 }}
    >
      <G>
        <Path
          style={{ fill: "#000" }}
          d="M192.1,236.3c-2.2-1-4.7-1.2-7-0.5c-3.4,0.8-6.4,2.7-8.4,5.5c-2.1,2.9-3.1,6.6-3,11.3c1.7,0.7,3.5,1.1,5.4,1.1
		c2.2,0.1,4.4-0.1,6.6-0.6c3.8-0.9,6.6-2.4,8.5-4.5c1.8-1.8,2.5-4.5,1.8-6.9C195.5,239.5,194.1,237.5,192.1,236.3z"
        />
        <Path
          style={{ fill: "#000" }}
          d="M99.1,51.3c0.8-2.4,0.2-5.1-1.5-7c-1.4-1.9-3.5-3-5.8-3.2c-2.4,0.1-4.8,1-6.5,2.7c-2.7,2.2-4.4,5.3-5,8.7
		c-0.7,3.5,0.1,7.3,2.4,11.5c1.8-0.1,3.6-0.6,5.3-1.4c2-0.9,3.9-2.1,5.6-3.5C96.5,56.5,98.3,53.9,99.1,51.3z"
        />
        <Path
          style={{ fill: "#000" }}
          d="M158.5,36.4c0.1-1.6-0.2-3.1-0.9-4.6c-0.7-1.2-1.8-2.2-3.1-2.7c-4-1.3-8.2-1.3-12.3-0.1
		c-1.3,0.5-2.5,1.4-3.2,2.6c-0.7,1.4-1,3-1,4.6L138,42l20.4,0.2L158.5,36.4z"
        />
        <Path
          style={{ fill: "#000" }}
          d="M148,0C66.3,0,0,66.3,0,148s66.3,148,148,148s148-66.3,148-148S229.7,0,148,0z M249.3,83.9
		c3.5,0.4,6.9,1.8,9.6,4.1c3.2,2.8,5.7,6.3,7.3,10.3c1.5,3.1,2.4,6.4,2.8,9.7c0.2,2.7,0,5.5-0.6,8.1l-8-1.9c0.6-1.9,0.8-4,0.6-6
		c-0.2-2.5-0.9-4.9-1.9-7.2c-3.2-7.1-8-9.8-14.3-8.2l9.4,20.8l-6.7,3L238.1,96c-5.4,3.8-6.6,9-3.5,15.8c1.1,2.5,2.6,4.8,4.5,6.9
		c1.7,1.9,3.6,3.6,5.7,5.1l-4.6,6c-2.6-1.7-5-3.8-7-6.2c-2.4-2.8-4.4-6-5.9-9.3c-5.9-13-2.3-22.4,10.7-28.3
		C241.5,84.3,245.4,83.6,249.3,83.9z M193.6,46c2.5-3,5.8-5.3,9.4-6.6c3.4-1.1,7.1-1.2,10.5-0.2c4.1,1.3,7.8,3.4,10.9,6.3
		c2.6,2.2,4.8,4.8,6.6,7.6c1.3,2.4,2.3,5,2.9,7.6l-8.2,1.8c-0.3-2-1-3.9-2-5.7c-1.2-2.2-2.8-4.1-4.7-5.7c-3.4-3-6.7-4.5-9.7-4.3
		c-3,0.1-6,1.8-8.8,5.1c-2.8,3.2-4.3,6.6-4.2,9.6c0.1,3.1,1.8,6.1,5.2,9.1c2.1,1.8,4.4,3.3,6.9,4.4c2.3,1.1,4.8,1.8,7.3,2.3
		l-1.8,7.5c-3.1-0.4-6.2-1.3-9-2.7c-3.4-1.6-6.5-3.6-9.2-6.1C184.8,66.9,184.1,56.8,193.6,46z M129.5,35.4c0-4.9,1.7-8.6,4.8-11.2
		c3.2-2.6,7.9-3.9,14.1-3.9c6.2,0.1,10.9,1.4,14,4.1c3.1,2.7,4.7,6.5,4.6,11.3l-0.2,25.9l-8.6-0.1l0.1-11.7L138,49.7l-0.1,11.8
		l-8.6-0.1L129.5,35.4z M69,47.9l6,7.1c-0.9-3.2-0.9-6.7,0.2-9.8c1.2-3.2,3.2-6.1,5.9-8.3c2.4-2.2,5.3-3.7,8.5-4.5
		c2.6-0.6,5.4-0.4,7.9,0.5c2.4,1,4.6,2.5,6.2,4.5c2,2.4,3.4,5.2,4,8.3c0.5,3.3,0.1,6.6-1.2,9.6c-1.7,3.7-4.2,7-7.4,9.5
		c-3.1,2.7-6.8,4.7-10.7,6l6.8,8l-6.6,5.6l-26.2-31L69,47.9z M29.1,103.4c0.4-3.5,1.4-6.9,3.1-10.1c1.5-3.2,3.3-6.2,5.5-9
		c1.7-2,3.8-3.8,6-5.3l5,6.3c-4.1,2.9-7.4,6.9-9.5,11.6c-1.4,2.9-2,5.1-2,6.8c0,1.7,0.6,2.8,1.8,3.4c0.7,0.4,1.5,0.5,2.3,0.3
		c0.9-0.4,1.8-1,2.4-1.8c1.3-1.5,2.4-3.1,3.4-4.8l2.4-4c1.8-3.1,4-6,6.5-8.5c1.6-1.6,3.6-2.7,5.9-3c2-0.1,4,0.3,5.8,1.2
		c3.8,1.8,6,4.6,6.5,8.4s-0.6,8.8-3.6,15c-3.6,7.5-8.5,13.1-14.8,16.8l-4.6-6.5c2.5-1.6,4.8-3.5,6.8-5.6c2.4-2.6,4.3-5.6,5.8-8.8
		c1.6-3.4,2.4-5.9,2.3-7.4c0.1-1.4-0.7-2.7-2-3.3c-0.7-0.4-1.5-0.4-2.3-0.2c-1,0.4-1.8,1.1-2.5,1.9c-1.2,1.4-2.2,3-3.2,4.6l-2.5,4
		c-3.1,5.2-6.2,8.6-9.3,10c-3,1.5-6.5,1.4-9.5-0.2c-2-0.9-3.6-2.5-4.7-4.4C29.2,108.5,28.8,106,29.1,103.4z M38.5,176
		c-2.2-1-1.7-4.8,0.4-10.6c-6-0.9-9.5-2.2-9.3-4.6v-0.1c0.2-2.4,4.1-3.1,10.2-2.9c-1-6-0.8-9.7,1.5-10.2h0.1
		c2.4-0.5,4.2,2.9,5.9,8.9c5.3-2.8,9-3.8,10.2-1.7c1.2,2.1-1.4,4.9-6.6,8.4c4.3,4.2,6.4,7.4,4.8,9.2c-1.6,1.8-5.1,0.2-10-3.7
		C43.1,174,40.7,176.9,38.5,176z M88.2,223.3l-10.3-11.6c-6.6,2.7-11.5,5.5-14.8,8.4c-2.2,2-3.4,3.9-3.7,5.9c-0.3,2.1,0.5,4.2,2,5.7
		c1.5,1.7,4.2,2.8,7.3,3.1l-1.2,7.5c-4-0.8-9.5-2.4-13.3-6.7c-1.9-2.1-3.2-4.6-3.7-7.4c-0.4-2.6-0.1-5.2,1-7.6
		c1.2-2.6,2.9-5,5.1-6.9c1.7-1.5,3.6-2.9,5.6-4c2-1.1,4.7-2.5,8-4L72,205l-9.3-10.5l5.6-5l25.6,28.8L88.2,223.3z M136,260.6
		c-1.5,5.3-4.5,8.6-9,9.9s-10.4,0.9-17.7-1.2c-3.2-0.9-6.2-2.2-9-3.8c-2.3-1.3-4.4-2.9-6.2-4.8l5.8-5.8c3.3,3.1,7.2,5.4,11.6,6.7
		c4.9,1.4,8.7,1.7,11.4,0.8c2.6-0.8,4.5-2.9,5.4-6.2l1.9-6.5c-2.1,2.6-5,4.5-8.2,5.5c-3.5,1-7.2,1-10.7-0.1
		c-2.7-0.7-5.2-2.1-7.2-4.1c-1.8-1.8-3-4.2-3.4-6.7c-0.5-2.8-0.3-5.7,0.6-8.4l3.2-11l8.3,2.4l-2.9,10.2c-1.5,5.3,0.3,8.8,5.5,10.3
		c3.7,1.1,7.7,0.3,10.8-2.1c3.4-2.5,6.3-6.5,8.7-12l8.3,2.4L136,260.6z M147.8,213c-35.9,0-65-29.1-65-65s29.1-65,65-65
		s65,29.1,65,65S183.7,213,147.8,213z M204.3,247.6c-1,3.1-2.9,5.9-5.4,8c-3.2,2.6-6.9,4.3-10.9,5.1c-4,1-8.1,1.1-12.2,0.5l2.4,10.2
		l-8.4,2l-9.5-39.4l8.4-2l2.2,9c0.6-3.3,2.2-6.3,4.6-8.7c2.5-2.4,5.6-4,9-4.8c3.1-0.9,6.4-0.9,9.6-0.2c2.6,0.6,5,2,6.8,4
		c1.7,1.9,3,4.3,3.5,6.8C205.3,241.4,205.2,244.6,204.3,247.6z M253,218.7c-1.3,3.4-3.2,6.7-5.5,9.6c-8.6,11.3-18.6,12.7-30,4
		c-3.2-2.3-5.7-5.3-7.2-8.9c-1.3-3.3-1.6-7-0.8-10.5c1-4.1,2.9-8,5.6-11.3c2-2.8,4.4-5.2,7.2-7.2c2.3-1.5,4.8-2.6,7.4-3.3l2.1,8
		c-2,0.4-3.9,1.2-5.5,2.3c-2.1,1.4-3.9,3.1-5.4,5.1c-4.8,6.2-4.9,11.7-0.5,16.5l13.8-18.1l5.8,4.5l-13.8,18c5.9,3,11.1,1.5,15.6-4.4
		c1.7-2.2,3-4.6,4-7.2c0.9-2.4,1.5-4.9,1.8-7.4l7.4,1.2C254.9,212.7,254.2,215.8,253,218.7z M260.7,177.4c-2.3,1-4.8-2.1-7.6-7.8
		c-5.1,4-8.8,5.8-10.5,3.8h0c-1.7-1.9,0.5-5.2,5-9.6c-5.4-3.6-8.2-6.6-6.9-8.8V155c1.3-2.2,5.1-1.1,10.7,1.8
		c1.8-6.2,3.7-9.8,6.2-9.2h0.1c2.5,0.6,2.7,4.5,1.6,10.8c6.5-0.3,10.5,0.5,10.7,3v0.1c0.3,2.5-3.5,3.9-9.7,4.9
		C262.5,172.3,263,176.4,260.7,177.4z"
        />
        <Path
          style={{ fill: "#000" }}
          d="M198.2,127.6L198.2,127.6c-0.7-1.7-2.2-4-5.6-5.5c-5.6-2.4-14.5-1.7-23.5,0.3c-5.8-4.8-13.2-7.7-21.3-7.7
		c-17,0-31.1,12.8-33.1,29.3c-8.2,4.9-15.2,10.5-17.6,16.1c-1.2,2.8-1.3,5.6-0.3,8.1c2,5,7.6,6.8,14.7,6.8c4.5,0,9.5-0.7,14.5-1.8
		c5.8,5,13.4,8.1,21.7,8.1c17.2,0,31.4-13,33.1-29.8C195.2,143,201,134.9,198.2,127.6z M182.4,141.2c-0.5,0.4-1.1,0.8-1.7,1.2
		c-0.4-2.2-1-4.4-1.8-6.4c-20.8,3.2-45.7,12.4-61.8,24.8c0.8,2,1.8,3.9,3,5.7c-9.9,1.6-15.2,0.6-15.9-1.1c-0.1-0.2-0.3-0.8,0.2-2.1
		c1.1-2.5,4.4-5.9,10.5-10c0,0,0,0.1,0,0.1c0.2-0.2,0.5-0.4,0.8-0.6c9.7-7.5,37.1-19.3,56.8-22.9c1-0.2,1.9-0.3,2.9-0.5c0,0,0,0,0,0
		c3.2-0.5,6-0.8,8.3-0.8c2.6,0,4.5,0.3,5.8,0.9c1.1,0.5,1.3,0.9,1.4,1.1C191.7,132.7,188.5,136.8,182.4,141.2z"
        />
      </G>
    </Svg>
  );
}

function SvgSeparator() {
  return (
    <View
      style={{
        borderBottom: "1px solid black",
        width: "100%",
        marginVertical: "10px",
      }}
    />
  );
}

// Create Document Component
export default function CartQuotePdf({ cartDetails }: Props) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.licenseDetails}>
          <View style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
            <Logo />
            <Text>{dayjs().format("MMM DD, YYYY")}</Text>
          </View>
          <SvgSeparator />
          <Text>License Holder: {cartDetails.licenseHolder?.name}</Text>
          <Text>Company Size: {cartDetails.companySizeString()}</Text>
        </View>
        <View style={styles.licenseDetails}>
          {Object.entries(cartDetails.families).map(
            ([familyName, familyDetails]) => {
              if (familyDetails.items.length === 0) {
                return;
              }

              return (
                <>
                  <Text>{familyName}</Text>
                  <Text>Platforms: {familyDetails.platforms?.join(", ")}</Text>

                  {familyDetails.items.map((entry) => {
                    return (
                      <>
                        {/* <hr className="my-4 w-full flex-row items-center justify-center" /> */}
                        <View style={styles.spacedRow}>
                          <View
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Text>{entry.name}</Text>
                          </View>
                          <Text>$100.00</Text>
                        </View>
                      </>
                    );
                  })}
                </>
              );
            }
          )}
        </View>
        <View style={styles.spacedRow}>
          <Text>Subtotal</Text>
          <Text>$100.00 USD</Text>
        </View>
        <View style={styles.spacedRow}>
          <Text style={{ color: "#1c8249" }}>Discounts</Text>
          <Text style={{ color: "#1c8249" }}>-$100.00 USD</Text>
        </View>
        <View style={styles.spacedRow}>
          <Text>Total</Text>
          <Text>$100.00 USD</Text>
        </View>
      </Page>
    </Document>
  );
}
